import {
  FETCH_INVITATION_CODE,
  FETCH_INVITED_LIST,
  FETCH_TOTAL_GIFT,
  INVITATION_BY_SMS,
  REMINDER,
  SETTLEMENT,
} from '../actions/types'

export interface Code {
  code: string
  link: string
}
export interface InvitationCode {
  data: Code | null
  loading: boolean
}
export const invitationCode = (
  state: InvitationCode = { data: null, loading: false },
  action,
) => {
  switch (action.type) {
    case FETCH_INVITATION_CODE:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

export interface InvitationBySMS {
  data: { mobile: number; message: string }
  loading: boolean
}

export const invitationBySMS = (
  state: InvitationBySMS = { data: { mobile: 0, message: '' }, loading: false },
  action,
) => {
  switch (action.type) {
    case INVITATION_BY_SMS:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

export interface SettlementType {
  data: { code: string }
  loading: boolean
}
export const settelement = (
  state: SettlementType = { data: { code: '' }, loading: false },
  action,
) => {
  switch (action.type) {
    case SETTLEMENT:
      return {
        data: action.data,
        loading: action.loading,
      }
    default:
      return state
  }
}

export interface InvitedInfo {
  name: string
  family: string
  mobile?: number
}
export interface InvitedList {
  data: InvitedInfo[]
  loading: boolean
}

export const invitedList = (
  state: InvitedList = { data: [], loading: false },
  action,
) => {
  switch (action.type) {
    case FETCH_INVITED_LIST:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

export interface TotalGift {
  data: { total_stored_gift: string } | null
  loading: boolean
}

export const totalGift = (
  state: TotalGift = { data: null, loading: false },
  action,
) => {
  switch (action.type) {
    case FETCH_TOTAL_GIFT:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}

export interface ReminderType {
  data: { mobile: number }
  loading: boolean
}
export const reminderReducer = (
  state: ReminderType = { data: { mobile: 0 }, loading: false },
  action,
) => {
  switch (action.type) {
    case REMINDER:
      return {
        data: action.data,
        loading: action.loading,
      }

    default:
      return state
  }
}
